import apiClient from "./baseService";
import {handleAxiosError} from "./axiosErrorHandler";

export interface CompanyBrandingResponse {
    logoUrl: string | null;
    isEnabled?: boolean;
    success?: boolean;
}

export interface UpdateCompanyBrandingParams {
    logo?: File | null;
    isEnabled?: boolean;
}

export const getCompanyBranding = async (companyId: string): Promise<CompanyBrandingResponse> =>
    await apiClient
        .get<CompanyBrandingResponse>(`/companies/${companyId}/branding`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const getCompanyEffectiveBranding = async (companyId: string): Promise<CompanyBrandingResponse> =>
    await apiClient
        .get<CompanyBrandingResponse>(`/companies/${companyId}/branding/effective`)
        .then((response) => response.data)
        .catch(handleAxiosError);

export const updateCompanyBranding = async (
    companyId: string,
    params: UpdateCompanyBrandingParams,
): Promise<CompanyBrandingResponse> => {
    const formData = new FormData();

    if (params.logo) {
        formData.append("logo", params.logo);
    }

    if (params.isEnabled !== undefined) {
        formData.append("isEnabled", params.isEnabled.toString());
    }

    return await apiClient
        .patch<CompanyBrandingResponse>(`/companies/${companyId}/branding`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then((response) => response.data)
        .catch(handleAxiosError);
};
